module.exports = __webpack_public_path__ + "static/media/ic_xiaofeng.1eb6bb92.png";